import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PluginShareFeedbackMainAppComponent } from './components/main/main.component';

export const shareFeedbackAppRoutes : Routes = [
    {
        // @deprecated oct-2026: legacy plugin prefix route, the screen is now served without /p
        // path: 'p/feedback/:project',
        // same shape as the bridges (e.g. filecomparison/project/:pid)
        path: 'feedback/project/:project',
        component: PluginShareFeedbackMainAppComponent,

    }
];

@NgModule({
  imports: [RouterModule.forChild(shareFeedbackAppRoutes)],
  exports: [RouterModule]
})
export class ShareFeedbackAppRouterModule { }
